import React from 'react';
import ImageWithFallback from 'components/ImageWithFallback';
import {textTruncateByLength} from 'utils/other';

const MobileEntityListItem = ({entity, pendingEntities}) => {
    return (
        <div className="mobile-entity-list-item">
            {/*item*/}
            <div className="mobile-entity-list-item__logo">
                {entity.logoUrl ?
                    <ImageWithFallback
                        alt={`entity-filter-${entity.id}`}
                        height={40}
                        src={entity.logoUrl}
                        width={40}
                        style={{objectFit: 'contain'}}
                        itemTitle={entity.title}
                        fallbackColor={entity.color}
                    />
                    :
                    <div className="icon-with-letter" style={{backgroundColor: entity.color}}>
                        {entity.title && entity.title[0].toUpperCase()}
                    </div>
                }
            </div>
            <div className="mobile-entity-list-item__content">
                <div className="d-flex align-items-center">
                    <div className="mobile-entity-list-item__title">{entity.title && textTruncateByLength(entity.title, 24)}</div>
                    {pendingEntities.indexOf(entity.id) > -1 &&
                    <div className="entity-list-item__status">
                        <div className="ml-2"
                             style={{
                                 height: '10px',
                                 width: '10px',
                                 backgroundColor: '#f1c231',
                                 borderRadius: '50%',
                             }}
                        />
                    </div>
                    }
                </div>
                <div className="mobile-entity-list-item__domain">
                    {entity.domain ? textTruncateByLength(entity.domain, 32) : ''}
                </div>
            </div>
        </div>
    );
};

export default MobileEntityListItem;
